import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/river2/pc/');
export default function F() {
    const { useLang } = useGlobal();
    const { t } = useLang('productriver2');

    return (
        <div className={`${css.F_6} river2_detials_F`}>
            <div className={`sticky-wrapper`}>
                <div className="text-wrapper">
                    <div className="upper-title">{t('river2.details.sec6_upper_title')}</div>
                    <div className="title">{t('river2.details.sec6_title')}</div>
                    <div className="desc">
                        {t.rich('river2.details.sec6_desc', {
                            line1: (child: any) => <span className="green">{child}</span>,
                            // line2: (child: any) => <span className="green">{child}</span>,
                            // line3: (child: any) => <span className="green">{child}</span>,
                        })}
                    </div>
                </div>
                <div className="img-wrapper">
                    <div className="img-wrapper__rel">
                        <EFPic
                            name={["6.webp", "6.jpg"]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('river2.details.sec6_title')}
                            aria-label={t('river2.details.sec6_title')}
                        />
                        <p className="year">{t('river2.details.sec6_year')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
